import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { allTrainingListDetails } from "../../../redux/actions/payment/training_action";
import AlertMessage from "../../../common/actions/AlertMessage";
import Loader from "../../../common/loaders/Loader";
import PageTitle from "../../../common/shared/PageTitle";
import MoneyIcon from "../../../common/icons/moneyIcon";
import DownloadButton from "../../../common/buttons/DownloadButton";
import EditButton from "../../../common/buttons/EditButton";
import Modal from "../../../common/actions/Modal";
import InputArea from "../../../common/forms/InputArea";
import saveDownload from "../../../utils/downloadFile";
import { Card, CardBody } from "@material-tailwind/react";
import { DataGrid } from "@mui/x-data-grid";
import { manualTrainingPayment } from "../../../redux/actions/payment/training_action";

function SingleTraining({ paidOnly = false }) {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [editLoading, setEditLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [formData, setFormData] = useState({});

  const dispatch = useDispatch();

  const { data, message } = useSelector((state) => state.training);
  const details = Array.isArray(data?.details) ? data.details : [];
  const paidDetails = details.filter((row) => row.status === 1);
  const visibleDetails = paidOnly
    ? paidDetails
    : details.filter((row) => row.status === 1 || row.status === 0);

  const paidTrainingDetails = paidDetails.map((row) => ({
    bar_number: row.bar_number ?? "",
    fullname:
      row.fullname ??
      row.full_name ??
      row.name ??
      [
        row.first_name ?? row.white_list?.first_name,
        row.last_name ?? row.white_list?.last_name,
      ]
        .filter(Boolean)
        .join(" "),
    phone_number:
      row.phone_number ??
      row.phone ??
      row.user?.phone ??
      row.white_list?.phone ??
      "",
    email: row.email ?? row.user?.email ?? row.white_list?.email ?? "",
  }));

  const updateFormValue = ({ updateType, value }) => {
    setFormData((current) => ({ ...current, [updateType]: value }));
  };

  const handleManual = async (event) => {
    event.preventDefault();
    setEditLoading(true);

    const result = await dispatch(
      manualTrainingPayment({
        productId: id,
        id: formData._id ?? formData.id,
        notes: formData.notes,
      }),
    );

    setEditLoading(false);
    if (!result?.error) {
      setEditModal(false);
      dispatch(allTrainingListDetails(id));
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "bar_number", headerName: "Bar Number", width: 100 },
    // { field: "amount", headerName: "Amount", width: 100 },
    // { field: "date_paid", headerName: "Date Paid", width: 150 },
    // { field: "type", headerName: "Type", width: 150 },
    { field: "chamber", headerName: "Chamber", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      renderCell: (params) => {
        const isPaid = params.row.status === "Paid";

        return (
          <span
            className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${
              isPaid
                ? "bg-green-50 text-green-700 ring-green-600/20"
                : "bg-orange-50 text-orange-700 ring-orange-600/20"
            }`}
          >
            {params.row.status}
          </span>
        );
      },
    },
  ];

  if (!paidOnly) {
    columns.push({
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        const isManual =
          params.row.method === 0 ||
          `${params.row.method}`.toLowerCase().includes("manual");

        return (
          params.row.originalStatus === 0 &&
          isManual && (
            <EditButton
              onClick={() => {
                setFormData({ ...params.row, notes: "" });
                setEditModal(true);
              }}
            />
          )
        );
      },
    });
  }

  useEffect(() => {
    dispatch(allTrainingListDetails(id)).finally(() => setLoading(false));
  }, [dispatch, id]);

  return (
    <>
      {message && <AlertMessage type="error" message={message} />}

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex justify-between p-4">
            <div className="flex items-center">
              <PageTitle
                title="Payment List"
                // title={data.product}
                subheading={visibleDetails.length}
                icon={<MoneyIcon />}
              />
            </div>

            <div className="flex items-center gap-4">
              <DownloadButton
                onClick={() =>
                  saveDownload(paidTrainingDetails, "Meeting & Training")
                }
                disabled={!paidTrainingDetails.length}
              />
            </div>
          </div>

          {/* <PaymentTable data={data.details} columns={columns} /> */}

          <Card className="w-full p-6 shadow-xl mb-20">
            <CardBody>
              <DataGrid
                sx={{ border: 0 }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      date_paid: false,
                    },
                  },
                }}
                rows={visibleDetails.map((row, index) => ({
                  ...row,
                  arrayIndex: index,
                  originalStatus: row.status,
                  status: row.status === 1 ? "Paid" : "Pending",
                }))}
                columns={columns}
              />
            </CardBody>
          </Card>
          {!paidOnly && editModal && (
            <Modal
              title="Complete Manual Processing"
              open={editModal}
              content={
                <form>
                  <InputArea
                    defaultValue={formData.notes}
                    updateType="notes"
                    labelTitle="Notes"
                    updateFormValue={updateFormValue}
                    required
                  />
                </form>
              }
              closeLabel="Close"
              actionLabel="Proceed"
              onClose={() => setEditModal(false)}
              onAction={handleManual}
              loading={editLoading}
            />
          )}
        </>
      )}
    </>
  );
}

export default SingleTraining;
